module.exports = __webpack_public_path__ + "img/syukyaku-EC-mo-004.be46d1cc.jpg";